import { getCatalog } from "../../i18n";
import { usePresentedSnapshot } from "../../presentation/hooks";
import { focusTargetEntityId, useNexusStore } from "../../store/nexusStore";

export function AccessibleSystemNavigator() {
  const snapshot = usePresentedSnapshot();
  const locale = useNexusStore((state) => state.locale);
  const focus = useNexusStore((state) => state.focus);
  const activateNode = useNexusStore((state) => state.activateNode);
  const focusOrbital = useNexusStore((state) => state.focusOrbital);
  const accessibleMode = useNexusStore((state) => state.accessibleMode);
  const toggleAccessibleMode = useNexusStore((state) => state.toggleAccessibleMode);
  const ui = getCatalog(locale).ui;
  if (!snapshot) return null;
  const current = focusTargetEntityId(focus);

  return (
    <nav className="semantic-map" aria-label={ui.semanticMap}>
      <p>{ui.semanticMapHint}</p>
      <button className="semantic-map__mode" onClick={toggleAccessibleMode} aria-pressed={accessibleMode}>
        {accessibleMode ? ui.accessibleObservatoryOn : ui.accessibleObservatoryOff}
      </button>
      <ul>
        {snapshot.nodes.map((node) => (
          <li key={node.id}>
            <button
              data-node-id={node.id}
              aria-current={current === node.id ? "true" : undefined}
              onClick={() => activateNode(node.id)}
            >
              <strong>{node.label}</strong>
              <span>{node.eyebrow}</span>
            </button>
          </li>
        ))}
      </ul>
      <p>{ui.orbitalHeading}</p>
      <ul>
        {snapshot.orbitalNodes.map((orbital) => (
          <li key={orbital.id}>
            <button
              aria-current={current === orbital.id ? "true" : undefined}
              onClick={() => focusOrbital(orbital.parentId, orbital.id)}
            >
              <strong>{orbital.label}</strong>
              <span>{orbital.eyebrow}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
